export const ROUTER_NAME_WORKBENCH = 'workbenchApp';

export const ROUTER_PATH_WORKBENCH = '/workbench-app';
